import {Component, Input}                                                    from "@angular/core";
import {NgbActiveModal}                                                      from "@ng-bootstrap/ng-bootstrap";
import {MessageCollection}                                                   from "../../shared/api/messages/api.models";
import {Blob}                                                                from '../../shared/api/attachments/api.models';
import {ModalService}                                                        from '../../shared/modal.service';
import {Api}                                                                 from '../../shared/api.service';


@Component({
    selector: 'message-modal',
    template: require('./message.modal.html'),
    styles: [require('./message.modal.scss')]
})

export class MessageModal {
    @Input() messageCollection: MessageCollection;
    @Input() showRemoveButton: boolean = false;
    @Input() showEditButton: boolean = false;

    public blob: Blob;

    constructor(public activeModal: NgbActiveModal, private api: Api, private modal: ModalService) {}

    editMessage() {
        const data = {
            type: 'edit',
            messageId: this.messageCollection.id
        }
        this.activeModal.dismiss(data);
    }

    remove() {
        this.activeModal.close();
    }

    cancel() {
        this.activeModal.dismiss();
    }

    showAttachment(event: Event, content, id: number) {
        event.preventDefault();

        this.api.attachments().blob(id).subscribe((attachment: Blob) => {
            this.blob = attachment;
            this.modal.custom(content, {size : 'lg'});
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/components/message.modal.ts